import { spaces } from '@99designs/common/core/settings';
import React from 'react';
import DocumentTitle from 'react-document-title';
import styled from 'styled-components';

interface Props {
    title: string;
    textAlignment?: 'left' | 'center' | 'right';
}

const StyledHeader = styled.div<Pick<Props, 'textAlignment'>>`
    text-align: ${props => props.textAlignment};
    position: relative;
    padding-top: ${spaces.gutter}px;
    padding-bottom: ${spaces.gutter}px;
`;

const Header: React.SFC<Props> = ({ children, title, textAlignment = 'left' }) => {
    return (
        <DocumentTitle title={title}>
            <StyledHeader textAlignment={textAlignment}>{children}</StyledHeader>
        </DocumentTitle>
    );
};

export default Header;
